import { render, staticRenderFns } from "./ApriaReservaDeLaBiosfera.vue?vue&type=template&id=98181f38&scoped=true&lang=pug"
import script from "./ApriaReservaDeLaBiosfera.vue?vue&type=script&lang=js"
export * from "./ApriaReservaDeLaBiosfera.vue?vue&type=script&lang=js"
import style0 from "./ApriaReservaDeLaBiosfera.vue?vue&type=style&index=0&id=98181f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98181f38",
  null
  
)

export default component.exports